const addMessage = (state, action) => {
  const newMessage = {
    id: state.nextId ?? 1,
    text: action.payload.text,
    type: action.payload.type,
  }
  state.nextId = newMessage.id + 1
  if (state.messages.length > 10) {
    state.messages = [newMessage]
  } else {
    state.messages.push(newMessage)
  }
  return state
}
const dismissMessage = (state, action) => {
  state.messages = state.messages.filter((message) => message.id !== action.payload)
  return state
}
const emptyMessages = (state, action) => {
  state.messages = []
  return state
}

const reducers = {
  addMessage,
  dismissMessage,
  emptyMessages,
}

export default reducers
